export interface RegisterFormState {
  name: string;
  email: string;
  phone: string;
  password: string;
}

export type RegisterFormErrors = Partial<Record<keyof RegisterFormState, string>>;

export const MIN_PASSWORD_LENGTH = 6;

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_COMPLETE_REGEX = /^\(\d{2}\) \d{4,5}-\d{4}$/;

export function validateRegisterForm(form: RegisterFormState): RegisterFormErrors {
  const errors: RegisterFormErrors = {};

  if (!form.name.trim()) {
    errors.name = 'Informe seu nome.';
  }

  if (!form.email.trim()) {
    errors.email = 'Informe seu e-mail.';
  } else if (!EMAIL_REGEX.test(form.email.trim())) {
    errors.email = 'Confira o e-mail, como maria@email.com.';
  }

  if (!form.phone.trim()) {
    errors.phone = 'Informe seu celular.';
  } else if (!PHONE_COMPLETE_REGEX.test(form.phone)) {
    errors.phone = 'Confira o celular, como (85) 99999-9999.';
  }

  if (!form.password) {
    errors.password = 'Crie uma senha.';
  } else if (form.password.length < MIN_PASSWORD_LENGTH) {
    errors.password = `A senha precisa de pelo menos ${MIN_PASSWORD_LENGTH} caracteres.`;
  }

  return errors;
}
